import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import Twitter from "../../../img/Twitter.svg";
import Facebook from "../../../img/Facebook.svg";
import Instagram from "../../../img/Instagram.svg";
import Flickr from "../../../img/Flickr.svg";
import ToTop from "../template/toTop";

const Footer = () =>{

      return(
          <footer>
             <Container fluid={'xxl'}>
                <Row>
                   <Col xs={'12'} md={'auto'}>
                      <Row>
                         <Col>
                            <p className="mb-0"><strong>Nuoto Sport Locarno</strong></p>
                            <p className="mb-0">Casella postale 131 - 6604 Locarno</p>
                            <p className="mb-0"> CCP 65-2930-2 / IBAN: <span className="nowrap-text">CH35 0900 0000 6500 2930 2</span>
                            </p>
                            <p className="mb-0"><a href="mailto:info@nuotosportlocarno.ch">info@nuotosportlocarno.ch</a>
                            </p>
                            <p className="mb-0">Tel. e fax <a href="tel:+41792071465">+41 79 207 14 65</a></p>
                         </Col>
                         <Col xs={'auto'}>
                            <p className="mb-0"><a href="https://www.nuotosportlocarno.ch/nsl/privacy">Privacy</a></p>
                            <p className="mb-0"><a href="https://www.nuotosportlocarno.ch/nsl/policy">Policy</a></p>
                         </Col>
                      </Row>
                   </Col>
                   <Col xs={'12'} md>
                      <div className="social-links mt-3 mt-md-0 justify-content-md-end">
                         <a href="https://www.facebook.com/nuotosportlocarno/" target="_blank" rel="noreferrer">
                            <img src={Facebook} alt={'icon facebook'}/>
                         </a>
                         <a href="https://www.instagram.com/nuoto_sport_locarno/" target="_blank" rel="noreferrer">
                            <img src={Instagram} alt={'icon instagram'} />
                            </a>
                         <a href="https://twitter.com/NuotoSportLocar" target="_blank" rel="noreferrer">
                            <img src={Twitter} alt={'icon twitter'} />
                         </a>
                         <a href="https://www.flickr.com/photos/fotonsl/sets/" target="_blank" rel="noreferrer">
                            <img src={Flickr} alt='icon flickr'/>
                         </a>
                      </div>
                   </Col>
                </Row>
             </Container>
             <ToTop />
          </footer>
      );
}
export default Footer;